module.exports = __webpack_public_path__ + "static/img/fujian.4dcbde6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/fujian.png
// module id = 06h4
// module chunks = 96